import { useHandleResponse } from '@/utils/useHandleResponse';
import { useMutation } from '@tanstack/react-query';
import { App, Button, Checkbox, Col, Divider, Form, Input, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField, updateProps } from '../../../contextRedux/ProviderGroup/ProviderGroupModel';
import ProviderGroupService from '../../../services/providerGroup/ProviderGroupService';
import { RootState } from '../../../store';
import useWindowSize from '../../../utils/useWindowSize';

const ProviderGroupForm: FC<any> = () => {
  const [form] = useForm();
  const { message } = App.useApp();
  const handleResponse = useHandleResponse();
  const dispatch = useDispatch();
  const width = useWindowSize();

  const providerGroup = useSelector((state: RootState) => state.models.providerGroup);

  const initialValues = {
    id: useSelector((state: RootState) => state?.models?.providerGroup?.id),
    name: useSelector((state: RootState) => state?.models?.providerGroup?.name),
    isActive: useSelector((state: RootState) => state?.models?.providerGroup?.isActive),
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fieldsValue = {
      ...form.getFieldsValue(true),
      isActive: e.target.checked,
    };
    form.setFieldsValue(fieldsValue);
  };

  const onSaveProviderGroupType = async () => {
    saveProviderGroupType(providerGroup);
  };

  const { mutate: saveProviderGroupType, isPending: _isSavingProviderGroup } = useMutation({
    mutationFn: (formData: any) => ProviderGroupService.upsert(providerGroup.id, formData),
    onSuccess: (data: any) => {
      if (data) {
        handleResponse(data, data?.response?.name);
        dispatch(updateProps({ field: 'isModalVisible', value: false }));
        dispatch(updateProps({ field: 'refresh', value: !providerGroup.props.refresh }));
      }
    },
    onError: (error: any) => {
      message.error(error.message);
    },
  });

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  useEffect(() => {
    form.setFieldsValue(providerGroup);
  }, [providerGroup]);

  return (
    <Form
      form={form}
      name='providerGroupForm'
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      onFinish={onSaveProviderGroupType}
      layout='vertical'
    >
      <Divider />

      <Row
        gutter={16}
        style={{
          margin: 0,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Col
          xs={24}
          sm={12}
          md={8}
          style={{
            minWidth: width > 700 ? 300 : '100%',
            padding: 0,
            flex: 'none',
          }}
        >
          <Form.Item label='Denumire' name='name' rules={[{ required: true, message: 'Introdu denumire!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={12}
          md={8}
          style={{
            minWidth: width > 700 ? 300 : '100%',
            padding: 0,
            flex: 'none',
          }}
        >
          <Form.Item label='Status' name='isActive' valuePropName='checked'>
            <Checkbox onChange={() => handleCheckboxChange} />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button type='primary' htmlType='submit'>
          Finalizare
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ProviderGroupForm;
